import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-[800px] mx-auto grid gap-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                <span className="text-primary-500 mr-2">Q{i + 1}.</span>
                {item.question}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}